export const AGENTS_PATH = '/agents';
export const PRACTICE_PATH = '/practice';
export const USERS_PATH = '/users';
export const ROLES_PATH = '/roles';
export const EVENTS_PATH = '/events';
export const AUDIT_PATH = '/audit';
export const GLOBALS_PATH = '/globals';
export const VELLO_PATH = '/vello';
export const CS_VERSIONS_PATH = '/cs-versions';
